const setTokenInLocalStorage = tokenInfo => {
  localStorage.setItem("access_type", tokenInfo.type);

  localStorage.setItem("access_token", "Bearer " + tokenInfo.access_token);

  localStorage.setItem("refresh_token", tokenInfo.refresh_token);
};

// 2020-05-22, DB 설계 내용과 동일하게 field명 변경
const deleteTokenInLocalStorage = () => {
  localStorage.removeItem("access_token");
  localStorage.removeItem("refresh_token");
  localStorage.removeItem("director");
};

const setDirectorInfoLocalStorage = director => {
  localStorage.setItem("directorId", director.id);
  localStorage.setItem("directorName", director.name);
  localStorage.setItem("directorPhone", director.phone);
  localStorage.setItem("directorUserId", director.userId);

  localStorage.setItem("directorAccount", director.Account);
  localStorage.setItem("directorSecurityNumber", director.SecurityNumber);
  localStorage.setItem("directorMarketingAgree", director.marketingAgree);
};

const deleteDirectorTokenInLocalStorage = () => {
  localStorage.removeItem("access_token");
  localStorage.removeItem("refresh_token");
  localStorage.removeItem("directorId");
  localStorage.removeItem("directorName");
  localStorage.removeItem("directorPhone");
  localStorage.removeItem("directorUserId");

  localStorage.removeItem("directorAccount");
  localStorage.removeItem("directorSecurityNumber");
  localStorage.removeItem("directorMarketingAgree");
};

// 2020-05-22, DB 설계 내용과 동일하게 field명 변경
const setFuneralInfoLocalStorage = funeral => {
  localStorage.setItem("funeralId", funeral.id);
  localStorage.setItem("funeralName", funeral.name);
  localStorage.setItem("funeralPhone", funeral.phone);
  localStorage.setItem("funeralUserId", funeral.userId);
  localStorage.setItem("funeralAddr", funeral.addr);
  localStorage.setItem("funeralAddrName", funeral.addrName);
  localStorage.setItem("funeralAddrX", funeral.addrX);
  localStorage.setItem("funeralAddrY", funeral.addrY);
  localStorage.setItem("funeralAccount", funeral.Account);
  localStorage.setItem("funeralSecurityNumber", funeral.SecurityNumber);
  localStorage.setItem("funeralMarketingAgree", funeral.marketingAgree);
};

const deleteFuneralTokenInLocalStorage = () => {
  localStorage.removeItem("access_token");
  localStorage.removeItem("refresh_token");
  localStorage.removeItem("funeralId");
  localStorage.removeItem("funeralName");
  localStorage.removeItem("funeralPhone");
  localStorage.removeItem("funeralUserId");

  localStorage.removeItem("funeralAccount");
  localStorage.removeItem("funeralSecurityNumber");
  localStorage.removeItem("funeralMarketingAgree");

  localStorage.removeItem("funeralAddr");
  localStorage.removeItem("funeralAddrName");
  localStorage.removeItem("funeralAddrX");
  localStorage.removeItem("funeralAddrY");
};
// 2020-05-22, DB 설계 내용과 동일하게 field명 변경
const setCorpInfoLocalStorage = corp => {
  localStorage.setItem("corpId", corp.id);
  localStorage.setItem("corpName", corp.name);
  localStorage.setItem("corpPhone", corp.phone);
  localStorage.setItem("corpUserId", corp.userId);
  localStorage.setItem("corpAccount", corp.Account);
  localStorage.setItem("corpSecurityNumber", corp.SecurityNumber);
  localStorage.setItem("corpMarketingAgree", corp.marketingAgree);

  localStorage.setItem("corpApprove", corp.approve);
  localStorage.setItem("corpApprovePassword", corp.approvePassword);
};

const deleteCorpTokenInLocalStorage = () => {
  localStorage.removeItem("access_token");
  localStorage.removeItem("refresh_token");
  localStorage.removeItem("corpId");
  localStorage.removeItem("corpName");
  localStorage.removeItem("corpPhone");
  localStorage.removeItem("corpUserId");

  localStorage.removeItem("corpAccount");
  localStorage.removeItem("corpSecurityNumber");
  localStorage.removeItem("corpMarketingAgree");

  localStorage.removeItem("corpApprove");
  localStorage.removeItem("corpApprovePassword");
};

export {
  setTokenInLocalStorage,
  deleteTokenInLocalStorage,
  setDirectorInfoLocalStorage,
  deleteDirectorTokenInLocalStorage,
  setFuneralInfoLocalStorage,
  deleteFuneralTokenInLocalStorage,
  setCorpInfoLocalStorage,
  deleteCorpTokenInLocalStorage
};
